var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1411_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2322 6.10041C21.2322 2.26128 19.0699 0 15.4107 0H5.82243C2.16229 0 0 2.26128 0 6.10041V14.4621C0 18.3012 2.16229 20.5714 5.82243 20.5714H15.4145C19.0737 20.5714 21.236 18.3012 21.236 14.4621C21.236 10.623 21.2322 6.52456 21.2322 6.10041Z",
    fill: "#030229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7322 6.10041C21.7322 4.08904 21.1646 2.42706 20.0553 1.26525C18.943 0.100366 17.3451 -0.5 15.4107 -0.5H5.82243C3.88758 -0.5 2.28942 0.100344 1.17705 1.26522C0.0676095 2.42705 -0.5 4.08904 -0.5 6.10041V14.4621C-0.5 16.4735 0.0675826 18.1374 1.17669 19.3014C2.28884 20.4685 3.88701 21.0714 5.82243 21.0714H15.4145C17.3494 21.0714 18.9474 20.4685 20.0594 19.3013C21.1684 18.1374 21.736 16.4734 21.736 14.4621C21.736 12.5424 21.735 10.5579 21.7341 9.00033C21.7336 8.21738 21.7331 7.54246 21.7328 7.03784C21.7324 6.53841 21.7322 6.2058 21.7322 6.10041Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1411_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5727 10.799C13.8593 12.1966 15.0022 13.18 16.307 13.1544H22.1594C22.7023 13.1544 23.1427 12.6723 23.1427 12.0764V8.3566C23.1415 7.76198 22.7023 7.27862 22.1594 7.27734H16.2022C14.718 7.28246 13.5192 8.60339 13.5215 10.2312C13.5215 10.4218 13.539 10.6123 13.5727 10.799Z",
    fill: "#030229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0807 10.888L13.0806 10.888L13.0829 10.8994C13.4111 12.4999 14.7372 13.6826 16.3117 13.6544H22.1594C23.0205 13.6544 23.6427 12.9044 23.6427 12.0764L23.6427 8.3566L23.6427 8.35562C23.6411 7.53066 23.0217 6.77937 22.1606 6.77734H22.1594L16.2022 6.77734L16.2005 6.77735C14.3983 6.78356 13.019 8.37247 13.0215 10.2316C13.0215 10.4524 13.0418 10.6726 13.0807 10.888Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1411_1718)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2517,
    cy: 10.2155,
    rx: 1.17014,
    ry: 1.25948,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3218 10.2155C17.3218 10.8629 16.8359 11.375 16.2517 11.375C15.6675 11.375 15.1815 10.8629 15.1815 10.2155C15.1815 9.56811 15.6675 9.05605 16.2517 9.05605C16.8359 9.05605 17.3218 9.56811 17.3218 10.2155Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_1411_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0284 6.13629H5.03982C4.5915 6.13431 4.22908 5.75099 4.23096 5.28051C4.23285 4.81201 4.59434 4.43265 5.03982 4.43067H11.0321C11.4804 4.42869 11.8467 4.80904 11.8485 5.27952C11.8504 5.75099 11.488 6.13431 11.0397 6.13629H11.0321H11.0284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0326 4.53067L11.0321 4.53067L5.04005 4.53067C4.65407 4.53251 4.33265 4.86277 4.33096 5.28091M11.0326 4.53067L4.33096 5.28091M11.0326 4.53067C11.4213 4.52895 11.7469 4.86019 11.7485 5.27992C11.7502 5.70073 11.4279 6.03444 11.0395 6.03629H11.0321H11.0284H5.04003C4.65148 6.03444 4.32928 5.70066 4.33096 5.28091C4.33096 5.28091 4.33096 5.28091 4.33096 5.28091M11.0326 4.53067L4.33096 5.28091M4.33096 5.28091L4.23096 5.28051L4.33096 5.28091Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1411_1718",
    x: -25,
    y: -25,
    width: 71.2358,
    height: 70.5713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1411_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1411_1718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1411_1718",
    x: -11.4785,
    y: -17.7227,
    width: 59.6211,
    height: 55.8779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1411_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1411_1718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1411_1718",
    x: 0.081543,
    y: -6.04395,
    width: 32.3403,
    height: 32.5186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1411_1718"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1411_1718",
    result: "effect2_dropShadow_1411_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1411_1718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_1411_1718",
    x: -10.769,
    y: -10.5693,
    width: 37.6177,
    height: 31.7061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1411_1718"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1411_1718",
    result: "effect2_dropShadow_1411_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1411_1718",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.c9deedd3d06b00f2c9f30d1c1af43f30.svg";
export { ForwardRef as ReactComponent };